import React, { createContext, useContext, useState, useEffect } from 'react';

const CurrencyContext = createContext();

export const useCurrency = () => {
  const context = useContext(CurrencyContext);
  if (!context) {
    throw new Error('useCurrency must be used within a CurrencyProvider');
  }
  return context;
};

// Auto-detect user's country/currency
const detectCurrency = () => {
  // Check if user is in US (default to USD)
  const isUS = navigator.language?.includes('en-US') || 
               Intl.DateTimeFormat().resolvedOptions().timeZone?.includes('America') ||
               navigator.language === 'en-US';
  
  return isUS ? 'USD' : 'GBP';
};

export const CurrencyProvider = ({ children }) => {
  const [currency, setCurrency] = useState('GBP');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Check localStorage first, then auto-detect
    const savedCurrency = localStorage.getItem('LBH_CURRENCY');
    const detectedCurrency = savedCurrency || detectCurrency();
    
    setCurrency(detectedCurrency);
    setIsLoading(false);
  }, []);

  const switchCurrency = (newCurrency) => {
    setCurrency(newCurrency);
    localStorage.setItem('LBH_CURRENCY', newCurrency);
  };

  const formatPrice = (amount) => {
    const symbols = {
      'USD': '$',
      'GBP': '£',
      'EUR': '€'
    };
    const symbol = symbols[currency] || '£';
    return `${symbol}${amount}`;
  };

  const getCurrencySymbol = () => {
    const symbols = {
      'USD': '$',
      'GBP': '£',
      'EUR': '€'
    };
    return symbols[currency] || '£';
  };

  const value = {
    currency,
    setCurrency: switchCurrency,
    formatPrice,
    getCurrencySymbol,
    isLoading
  };

  return (
    <CurrencyContext.Provider value={value}>
      {children}
    </CurrencyContext.Provider>
  );
};

export default CurrencyContext;